(function() {
  const initSyncSlider = (section) => {
    const swiperEl = section.querySelector('.custom-slider-swiper-container');
    if (!swiperEl || swiperEl.classList.contains('swiper-initialized')) return;

    new Swiper(swiperEl, {
      slidesPerView: 1,
      loop: true,
      autoHeight: true, // 核心增加：根据内容自动调整高度，防止移动端截断
      effect: 'fade',
      fadeEffect: { crossFade: true },
      speed: 800,
      grabCursor: true,
      pagination: {
        el: section.querySelector('.custom-slider-pagination'),
        clickable: true,
      },
      navigation: {
        nextEl: section.querySelector('.nav-arrow.next'),
        prevEl: section.querySelector('.nav-arrow.prev'),
      },
    });
    swiperEl.classList.add('swiper-initialized');
  };

  const loadSwiper = (callback) => {
    if (window.Swiper) {
      callback();
    } else {
      // 动态加载 CSS
      if (!document.querySelector('#swiper-css')) {
        const link = document.createElement('link');
        link.id = 'swiper-css';
        link.rel = "stylesheet";
        link.href = "https://unpkg.com/swiper@8/swiper-bundle.min.css";
        document.head.appendChild(link);
      }
      // 动态加载 JS
      const script = document.createElement('script');
      script.src = "https://unpkg.com/swiper@8/swiper-bundle.min.js";
      script.onload = callback;
      document.head.appendChild(script);
    }
  };

  const startObserver = () => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          loadSwiper(() => initSyncSlider(entry.target));
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '200px' });

    document.querySelectorAll('.custom-slider-section').forEach(el => observer.observe(el));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserver);
  } else {
    startObserver();
  }
})();